import { render, staticRenderFns } from "./box_4.vue?vue&type=template&id=43d4c582&scoped=true"
import script from "./box_4.vue?vue&type=script&lang=js"
export * from "./box_4.vue?vue&type=script&lang=js"
import style0 from "./box_4.vue?vue&type=style&index=0&id=43d4c582&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d4c582",
  null
  
)

export default component.exports